<template>
  <div class="card">
    <div class="card-image grey lighten-3">
      <img :src="logo" alt="Court logo" class="logo-icons" >
    </div>
    <div class="card-content">
      <router-link class="grey-text text-darken-3 card-title" 
        :to="{name:'category',params:{slug:dataContent.slug},query:{id:dataContent.id}}"
        v-html="dataContent.name">
      </router-link>
      <span class="chip">{{dataContent.count}} Article<span v-if="dataContent.count > 1">s</span></span> 
    </div>
  </div>
</template>
<script>
import logo from '@/assets/court-logo.png'
export default {
name:"categoryCard",
props:{
  dataContent:{
    type:Object,
  }
},
data(){
  return {
    logo:logo,
  }
}
}
</script>
<style lang="scss" scoped>
.card {
  @media screen and (min-width:1024px) {
    min-height:320px
  }
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.02), 0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.02);
  .card-image {
    img.logo-icons {
      width: 80px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    min-height:180px;
  }
  .card-title {
    font-size:16px;
    font-weight:500;
    line-height: 22.5px;
  }
}
</style>